// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'primary', 'primary Fallback'"},"className":"__className_cae4e0","variable":"__variable_cae4e0"};